<template>
  <div class="py-2">
    <v-row no-gutters justify-space-between align="center">
      <v-col class="pa-0">
        <!-- DURATION -->
        <v-col v-if="isDurationEnabled" class="pa-0">
          <v-row no-gutters="">
            <v-col cols="12">
              <v-row no-gutters align="center">
                <v-col sm="auto" class="mr-2">
                  <span class="font-weight-bold">
                    {{
                      $t(
                        "serviceManagement.availabilityForm.form.duration.label"
                      )
                    }}:
                  </span>
                </v-col>
                <v-col sm="auto" mr-2>
                  <v-row class="no-gutters" align="center">
                    <v-col sm="auto">
                      <v-btn
                        icon
                        @click="decreaseDuration"
                        :disabled="duration.isLocked"
                        ><v-icon icon> keyboard_arrow_left </v-icon></v-btn
                      >
                    </v-col>
                    <v-col sm="auto" class="duration-field">
                      <v-text-field
                        class="input-field--small text-center"
                        :class="{ 'read-only': duration.isLocked }"
                        type="tel"
                        v-mask="['###']"
                        v-model="duration.value"
                        :readonly="duration.isLocked"
                        autofocus
                      ></v-text-field>
                    </v-col>
                    <v-col sm="auto">
                      <v-btn
                        icon
                        @click="increaseDuration"
                        :disabled="duration.isLocked"
                      >
                        <v-icon icon> keyboard_arrow_right </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col sm="auto" class="mr-2">
                  <span class="font-weight-bold">
                    {{
                      $t(
                        "serviceManagement.availabilityForm.form.duration.suffix"
                      )
                    }}
                  </span>
                </v-col>

                <v-col sm="auto">
                  <v-btn
                    icon
                    :disabled="duration.isLocked"
                    @click="resetDuration"
                  >
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-col>

                <v-col sm="auto" class="mr-2">
                  <v-btn icon>
                    <v-icon
                      color="primary"
                      v-if="duration.isLocked"
                      small
                      @click="confirmEditDurationDialog"
                      >edit</v-icon
                    ></v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <span class="error-message">
                {{ getDurationFieldError }}
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-col>

      <!-- CREATE-SAVE BUTTONS -->
      <v-col sm="auto" v-if="editPermission">
        <v-row no-gutters="">
          <v-col>
            <v-btn
              color="primary"
              small
              outlined
              rounded
              :disabled="!isDurationValid && isDurationEnabled"
              @click="openDialog('new')"
            >
              <span>{{ getAddTimespanBtnLabel }}</span>
            </v-btn>
          </v-col>
          <v-col class="ml-2">
            <v-btn
              color="primary"
              small
              rounded
              :disabled="isSaveButtonDisabled"
              @click="saveWeekAvailability()"
            >
              {{ $t("serviceManagement.availabilityForm.form.submit.edit") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- WEEK TABLE -->
    <v-row no-gutters>
      <v-col cols="12" v-for="(day, index) in grouppedTimespans" :key="index">
        <v-row
          no-gutters
          class="week-availability__row py-2"
          row
          justify="space-between"
          align="center"
        >
          <!-- COLUMN 1 -->
          <v-col class="sm-3 md-2 day-col">
            <v-row no-gutters align="center" justify="center">
              <v-col sm="auto">
                <h3 class="text-xs-center black--text">
                  {{ getFormattedDayName(day.name) }}
                </h3>
              </v-col>
            </v-row>
          </v-col>

          <!-- COLUMN 2 -->
          <v-col class="sm-9 md-10 pl-2">
            <span
              class="font-weight-light font-italic px-2"
              v-if="day.timespans.length === 0"
            >
              {{ $t("weekTimetable.noTimespansMsg") }}
            </span>
            <v-chip
              v-for="(item, index) in getSortedTimespans(day.timespans)"
              :key="index"
              class="text-caption font-weight-bold slot-chip mx-2"
              :close="editPermission"
              :color="item.isNew || item.isUpdated ? 'secondary' : 'primary'"
              text-color="white"
              x-large
              @click="openDialog('edit', item)"
              @click:close="removeTimespan(item)"
            >
              <v-container>
                <v-row no-gutters="" align="center">
                  <!-- CHIP MAIN CONTENT -->
                  <v-col @click="openDialog('edit', item)" class="mr-1">
                    <div class="d-inline-flex justify-content-between">
                      <div class="slot-chip__time-period pa-0 mr-1">
                        <span class="text-no-wrap">
                          {{ getFormattedTimePeriod(item) }}
                        </span>
                      </div>
                      <div
                        class="slot-chip__validation-period"
                        v-if="hasValidationPeriod(item) && item.doctorId"
                      >
                        <span class="text-no-wrap">
                          {{ getFormattedValidityPeriod(item) }}
                        </span>
                      </div>
                    </div>
                    <div>
                      <div class="slot-chip__doctor" v-if="item.doctorId">
                        <span>{{ getDoctorName(item) }}</span>
                      </div>
                      <div class="slot-chip__validation-period" v-else>
                        <span>
                          {{ getFormattedValidityPeriod(item) }}
                        </span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-chip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- NEW/EDIT SLOT DIALOG -->
    <v-dialog v-model="dialog" persistent width="70%">
      <v-card
        class="black--text d-flex flex-column custom-height-dialog"
        color="cardbg"
      >
        <v-card-title class="pb-0 mb-0 headline font-weight-bold black--text">{{
          getDialogTitle
        }}</v-card-title>
        <v-card-text class="flex-grow-1 overflow-y-auto">
          <v-form v-model="isFormValid">
            <v-row no-gutters>
              <!-- DAY RANGE -->
              <v-col cols="12" class="mb-4">
                <v-select
                  v-model="form.selectedDay"
                  :items="weekAvailability"
                  item-text="name"
                  item-value="id"
                  :placeholder="$t('weekTimetable.dialog.choose')"
                  class="dialog-form-input"
                  return-object
                  required
                  hide-details
                >
                  <span slot="prepend" class="title mt-1">
                    {{ $t("weekTimetable.dialog.day") }}
                  </span>
                </v-select>
              </v-col>

              <!-- DOCTOR -->
              <v-col cols="12" v-if="isDoctorFieldExist" class="mb-4">
                <v-select
                  :no-data-text="$t('weekTimetable.dialog.doctor.no-data')"
                  prepend-icon="fas fa-user-md fa-sm"
                  v-model="form.selectedDoctor"
                  :items="getDoctorsList"
                  :item-text="getDoctorName"
                  item-value="doctorId"
                  :placeholder="$t('weekTimetable.dialog.choose')"
                  class="dialog-form-input"
                  required
                  return-object
                >
                  <span slot="prepend" class="title mt-1">
                    {{ $t("weekTimetable.dialog.doctor.label") }}
                  </span>
                </v-select>
              </v-col>

              <!-- TIME RANGE -->
              <v-col cols="12" class="mt-4 mb-3">
                <!-- TIME RANGE -->
                <v-row
                  no-gutters
                  class="ma-0"
                  justify-space-between
                  style="height: auto"
                >
                  <!-- START TIME -->
                  <v-col sm="auto" class="mr-2">
                    <v-row no-gutters align="center">
                      <v-col>
                        <!-- START TIME -->
                        <label class="title black--text pt-1" for="">
                          {{ $t("weekTimetable.dialog.timespan.start") }}
                        </label>
                        <time-picker
                          input-width="200px"
                          close-on-complete
                          class="custom-time-picker ml-3"
                          hide-disabled-items
                          v-model="form.timespan.fromHHMM"
                          :hour-range="startTimeHourRange"
                          :minute-interval="minuteInterval"
                          :placeholder="$t('weekTimetable.dialog.choose')"
                        ></time-picker>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- END TIME -->
                  <v-col sm="auto">
                    <v-row no-gutters align="center">
                      <v-col>
                        <label class="title black--text pt-1" for="">
                          {{ $t("weekTimetable.dialog.timespan.end") }}
                        </label>
                        <time-picker
                          close-on-complete
                          input-width="200px"
                          class="custom-time-picker ml-3"
                          hide-disabled-items
                          :minute-interval="minuteInterval"
                          v-model="form.timespan.toHHMM"
                          :hour-range="endTimeHourRange"
                          :minute-range="endTimeMinuteRange"
                          :placeholder="$t('weekTimetable.dialog.choose')"
                        ></time-picker>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

              <!-- DATE RANGE -->
              <v-col cols="12" v-if="isDatePeriodExist" class="mt-3">
                <h1 class="title black--text mb-1">
                  {{ $t("weekTimetable.dialog.datePeriod.title") }}
                </h1>
                <v-radio-group
                  ref="slotValidityPeriodElem"
                  v-model="form.dateRange.type"
                  :mandatory="false"
                  class="mt-0"
                  @change="updateSlotValidationPeriod"
                  :rules="[validateSlotValidationPeriod]"
                >
                  <!-- ALWAYS -->
                  <v-radio
                    value="always"
                    class="radio-btn"
                    @change="resetRadioGroupData('always')"
                  >
                    <span
                      slot="label"
                      class="form-label font-weight-bold black--text"
                    >
                      {{ $t("weekTimetable.dialog.datePeriod.always") }}
                    </span>
                  </v-radio>

                  <!-- TO -->
                  <v-radio
                    value="to"
                    class="radio-btn"
                    @change="resetRadioGroupData('to')"
                  >
                    <v-row no-gutters slot="label">
                      <v-col>
                        <v-menu
                          v-model="datePicker3"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="dateToFormatted"
                              :label="$t('date')"
                              ref="toDateElem"
                              :disabled="form.dateRange.type != 'to'"
                              readonly
                              hide-details
                              v-on="on"
                            >
                              <span
                                slot="prepend"
                                class="form-label mr-2 font-weight-bold"
                              >
                                {{ $t("weekTimetable.dialog.datePeriod.to") }}
                              </span>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            :locale="getLocale"
                            :first-day-of-week="1"
                            class="date-picker"
                            :min="getNowDate"
                            v-model="form.dateRange.dates.to"
                            @input="updateDate('datePicker3')"
                            no-title
                            :header-date-format="customizeDatePickerHeader"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-radio>

                  <!-- PERIOD -->
                  <v-radio
                    value="period"
                    class="radio-btn"
                    @change="resetRadioGroupData('period')"
                  >
                    <v-row no-gutters slot="label">
                      <!-- PERIOD: FROM -->
                      <v-col sm="auto">
                        <v-menu
                          v-model="datePicker1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              ref="periodFromDateElem"
                              v-model="periodFromFormatted"
                              :label="$t('date')"
                              readonly
                              hide-details
                              :disabled="form.dateRange.type != 'period'"
                              v-on="on"
                            >
                              <span
                                slot="prepend"
                                class="form-label font-weight-bold mr-2"
                              >
                                {{
                                  $t(
                                    "weekTimetable.dialog.datePeriod.period.from"
                                  )
                                }}
                              </span>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            class="date-picker"
                            :min="getNowDate"
                            v-model="form.dateRange.dates.period.from"
                            :max="form.dateRange.dates.period.to"
                            :locale="getLocale"
                            :first-day-of-week="1"
                            @input="updateDate('datePicker1')"
                            no-title
                            :header-date-format="customizeDatePickerHeader"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>

                      <!-- PERIOD: TO -->
                      <v-col>
                        <v-menu
                          v-model="datePicker2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="periodToFormatted"
                              :label="$t('date')"
                              ref="periodToDateElem"
                              readonly
                              :disabled="
                                form.dateRange.type != 'period' ||
                                !form.dateRange.dates.period.from
                              "
                              hide-details
                              v-on="on"
                            >
                              <span
                                slot="prepend"
                                class="form-label font-weight-bold black--text mx-2"
                              >
                                {{
                                  $t(
                                    "weekTimetable.dialog.datePeriod.period.to"
                                  )
                                }}
                              </span>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            class="date-picker"
                            v-model="form.dateRange.dates.period.to"
                            :min="form.dateRange.dates.period.from"
                            :locale="getLocale"
                            :first-day-of-week="1"
                            no-title
                            @input="updateDate('datePicker2')"
                            :header-date-format="customizeDatePickerHeader"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-radio>

                  <!-- FROM -->
                  <v-radio
                    value="from"
                    class="radio-btn"
                    @change="resetRadioGroupData('from')"
                  >
                    <v-row no-gutters slot="label" class="align-center">
                      <v-col sm="auto" class="mr-2">
                        <span class="form-label font-weight-bold mr-2">
                          {{ $t("weekTimetable.dialog.datePeriod.from.part1") }}
                        </span>
                      </v-col>

                      <v-col>
                        <v-menu
                          v-model="datePicker4"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="dateFromFormatted"
                              :label="$t('date')"
                              ref="fromDateElem"
                              readonly
                              hide-details
                              :disabled="form.dateRange.type != 'from'"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            :locale="getLocale"
                            :first-day-of-week="1"
                            class="date-picker"
                            :min="getNowDate"
                            v-model="form.dateRange.dates.from"
                            @input="updateDate('datePicker4')"
                            no-title
                            :header-date-format="customizeDatePickerHeader"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>

                      <v-col ml-2>
                        <span class="form-label font-weight-bold black--text">
                          {{ $t("weekTimetable.dialog.datePeriod.from.part2") }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="mt-auto">
          <v-spacer></v-spacer>
          <v-btn
            class="mt-2 mb-2"
            color="primary"
            rounded
            outlined
            @click="closeDialog"
            >{{ $t("backButton") }}</v-btn
          >
          <v-btn
            class="mt-2 mb-2"
            color="primary"
            rounded
            :disabled="!isFormComplete"
            @click="submitTimespan"
          >
            <span>{{ getDialogSubmitBtnLabel }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Utils from "../Utils";
import ValidationRules from "./../views/validationRules";
let vrules = new ValidationRules();

const getSlotValidationDatePeriod = form => {
  let period = { validityFrom: null, validityTo: null };
  switch (form.dateRange.type) {
    case "always":
      period.validityFrom = null;
      period.validityTo = null;
      break;
    case "period":
      period.validityFrom = form.dateRange.dates.period.from;
      period.validityTo = form.dateRange.dates.period.to;
      break;
    case "from":
      period.validityFrom = form.dateRange.dates.from;
      break;
    case "to":
      period.validityTo = form.dateRange.dates.to;
      break;
    default:
      break;
  }
  return period;
};

const initFormFieldsData = () => {
  return {
    selectedDay: {
      id: null,
      name: null
    },
    selectedDoctor: { doctorId: null },
    timespan: {
      fromHHMM: {
        HH: null,
        mm: null
      },
      toHHMM: {
        HH: null,
        mm: null
      }
    },
    dateRange: {
      type: "always",
      dates: {
        period: {
          from: null,
          to: null
        },
        from: null,
        to: null
      },
      validityFrom: null,
      validityTo: null
    }
  };
};

export default {
  props: {
    editPermission: {
      type: Boolean,
      required: true,
      default: false
    },
    timespansList: {
      type: Array,
      required: true,
      default: () => []
    },
    formFields: {
      type: Object,
      required: true,
      default: () => {}
    },
    hasUnsavedChanges: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      duration: {
        available: false,
        isLocked: false,
        value: 0
      },
      durationTimeStep: 5,
      durationRules: [
        d =>
          !!d ||
          this.$t(
            "serviceManagement.availabilityForm.form.duration.validation-msgs.required"
          ),
        d =>
          d % this.durationTimeStep == 0 ||
          this.$t(
            "serviceManagement.availabilityForm.form.duration.validation-msgs.validity"
          )
      ],
      durationMeasurementUnits: [
        {
          id: "MINUTE",
          text: this.$t(
            "serviceManagement.availabilityForm.form.duration-units.minutes"
          )
        },
        {
          id: "HOUR",
          text: this.$t(
            "serviceManagement.availabilityForm.form.duration-units.hours"
          )
        },
        {
          id: "DAY",
          text: this.$t(
            "serviceManagement.availabilityForm.form.duration-units.days"
          )
        }
      ],
      datePicker1: false,
      datePicker2: false,
      datePicker3: false,
      datePicker4: false,
      isFormValid: true,
      rules: vrules,
      selectedTimespan: null,
      dialogMode: "new",
      dialog: false,
      minuteInterval: 5,
      form: initFormFieldsData(),
      weekAvailability: [
        { id: "MONDAY", name: this.$t(`days.monday`), timespans: [] },
        { id: "TUESDAY", name: this.$t(`days.tuesday`), timespans: [] },
        { id: "WEDNESDAY", name: this.$t(`days.wednesday`), timespans: [] },
        { id: "THURSDAY", name: this.$t(`days.thursday`), timespans: [] },
        { id: "FRIDAY", name: this.$t(`days.friday`), timespans: [] },
        { id: "SATURDAY", name: this.$t(`days.saturday`), timespans: [] },
        { id: "SUNDAY", name: this.$t(`days.sunday`), timespans: [] },
        { id: "WORKING", name: this.$t(`days.working`) },
        { id: "ANY", name: this.$t(`days.any`) }
      ]
    };
  },
  created() {
    this.duration.value = this.formFields.data.duration.value;
  },
  watch: {
    formFields: {
      deep: true,
      immediate: true,
      handler(val) {
        this.duration.available = val.data.duration.available;
        this.duration.isLocked = val.data.duration.isLocked;
      }
    },
    duration: {
      deep: true,
      handler(val) {
        if (this.duration.available && !val.isLocked) {
          this.isFormDirty = true;
        }
      }
    }
  },
  computed: {
    isFormDirty: {
      get() {
        return this.hasUnsavedChanges;
      },
      set(value) {
        this.$emit("updatependingchanges", value);
      }
    },
    timeList: {
      get() {
        return this.timespansList;
      },
      set(value) {
        this.$emit("updatetimelist", value);
      }
    },
    isSaveButtonDisabled() {
      if (this.isDurationEnabled) {
        return !this.isFormDirty || !this.isDurationValid;
      } else {
        return !this.isFormDirty;
      }
    },
    isDurationValid() {
      return (
        this.duration.value != undefined &&
        this.duration.value != null &&
        this.duration.value != "" &&
        this.duration.value >= 5 &&
        this.duration.value <= 180
      );
    },
    getDurationFieldError() {
      const DURATION = this.duration.value;
      const BASE_PATH =
        "serviceManagement.availabilityForm.form.duration.validationMessages";
      const MIN_VALUE = 5,
        MAX_VALUE = 180,
        STEP = 5;
      let constraint;
      if (DURATION == undefined || DURATION == null || DURATION == "")
        constraint = "required";
      else if (DURATION > MAX_VALUE) constraint = "maxValue";
      else if (DURATION < MIN_VALUE) constraint = "minValue";
      else if (DURATION % STEP != 0) constraint = "wrongFormat";
      let fullPath = `${BASE_PATH}.${constraint}`;
      return this.$t(fullPath) == fullPath ? "" : this.$t(fullPath);
    },
    getLocale() {
      return this.$i18n.locale;
    },
    isDurationEnabled() {
      return this.formFields.data.duration.available;
    },
    periodFromFormatted() {
      let fromDate = this.form.dateRange.dates.period.from;
      return this.formatDate(fromDate);
    },
    periodToFormatted() {
      let toDate = this.form.dateRange.dates.period.to;
      return this.formatDate(toDate);
    },
    dateFromFormatted() {
      let fromDate = this.form.dateRange.dates.from;
      return this.formatDate(fromDate);
    },
    dateToFormatted() {
      let toDate = this.form.dateRange.dates.to;
      return this.formatDate(toDate);
    },
    getDialogMaxWidth() {
      return 700;
    },
    getNowDate() {
      return dayjs().format("YYYY-MM-DD");
    },
    getDoctorsList() {
      return this.formFields.data.doctor?.value || [];
    },
    getAddTimespanBtnLabel() {
      return this.$t(`weekTimetable.addButton.slot`);
    },
    getDialogSubmitBtnLabel() {
      let translateString;
      if (this.dialogMode == "new") translateString = "create";
      else translateString = "edit";
      return this.$t(
        `${this.formFields.dialog[translateString].submitBtnLabelPath}`
      );
    },
    getDialogTitle() {
      let translateString;
      if (this.dialogMode == "new") translateString = "create";
      else translateString = "edit";
      return this.$t(`${this.formFields.dialog[translateString].titlePath}`);
    },
    isDoctorFieldExist() {
      return this.formFields.data.doctor.available;
    },
    isDatePeriodExist() {
      return this.formFields.data.datePeriod.available;
    },
    isFormComplete() {
      return (
        this.isFormValid &&
        this.form.selectedDay &&
        (!this.isDoctorFieldExist || this.form.selectedDoctor) &&
        this.form.timespan.fromHHMM.HH &&
        this.form.timespan.fromHHMM.mm &&
        this.form.timespan.toHHMM.HH &&
        this.form.timespan.toHHMM.mm
      );
    },
    startTimeHourRange() {
      return [[0, 23]];
    },
    endTimeHourRange() {
      let startHH = this.form.timespan.fromHHMM?.HH;
      if (!startHH) return [];
      return [[parseInt(startHH), 23]];
    },
    endTimeMinuteRange() {
      let startTimeHH = this.form.timespan.fromHHMM?.HH;
      let startTimeMM = this.form.timespan.fromHHMM?.mm;
      let endTimeHH = this.form.timespan.toHHMM?.HH;
      if (!startTimeMM || !endTimeHH) {
        return [];
      }
      let minuteSpots = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
      const IS_DURATION_AVAILABLE = this.formFields.data.duration?.available;
      if (!IS_DURATION_AVAILABLE) {
        if (endTimeHH == startTimeHH) {
          return minuteSpots.filter(ms => ms > startTimeMM);
        } else return minuteSpots;
      }
      let validMinuteSpots = minuteSpots.filter(minuteSpot => {
        let candidateEndTime = {
          HH: endTimeHH,
          mm: minuteSpot
        };
        let startTime = this.form.timespan.fromHHMM;
        if (this.compareTimes(startTime, candidateEndTime) != 1) return false;
        let timeDiff = this.getTimeDiff(startTime, candidateEndTime);
        let duration = this.duration.value;
        return timeDiff % duration == 0;
      });
      return validMinuteSpots;
    },
    grouppedTimespans() {
      let daysOfWeek = this.weekAvailability.slice(0, -2);
      daysOfWeek.forEach(dT => (dT.timespans = []));
      daysOfWeek.forEach(dayOfWeek => {
        if (!this.timeList) {
          dayOfWeek.timespans = [];
          return;
        }
        let dayTimespans = this.timeList.filter(timespan => {
          return (
            timespan.day == dayOfWeek.id.toUpperCase() ||
            timespan.day == "ANY" ||
            (timespan.day == "WORKING" &&
              dayOfWeek.id.toUpperCase() != "saturday".toUpperCase() &&
              dayOfWeek.id.toUpperCase() != "sunday".toUpperCase())
          );
        });
        dayOfWeek.timespans = dayTimespans.map(timespan => {
          let copy = { ...timespan };
          copy.fromHHMM = this.formatTimeToObject(timespan.fromHHMM);
          copy.toHHMM = this.formatTimeToObject(timespan.toHHMM);
          return copy;
        });
      });
      return daysOfWeek;
    },
    getDaysOfWeek() {
      return this.weekAvailability.slice(0, -2);
    }
  },
  methods: {
    hasValidationPeriod(item) {
      return (
        Object.prototype.hasOwnProperty.call(item, "validityFrom") &&
        Object.prototype.hasOwnProperty.call(item, "validityTo") &&
        (item.validityFrom || item.validityTo)
      );
    },
    customizeDatePickerHeader(d) {
      let [y, m] = d.split("-");

      if (m) {
        let translatedMonth = this.$t(`months.${Utils.getMonthFromNumber(m)}`);
        return `${translatedMonth} ${y}`;
      } else return y;
    },
    increaseDuration() {
      let newValue = this.duration.value + 5;
      this.duration.value = newValue > 180 ? 180 : newValue;
    },
    decreaseDuration() {
      let newValue = this.duration.value - 5;
      this.duration.value = newValue < 5 ? 5 : newValue;
    },
    resetDuration() {
      this.duration.value = 5;
    },
    confirmEditDurationDialog() {
      this.$store.commit(
        "confirm/openConfirmDialog",
        {
          title:
            "serviceManagement.availabilityForm.form.duration.confirmDialog.title",
          message:
            "serviceManagement.availabilityForm.form.duration.confirmDialog.msg",
          cancelBtnLabel: "cancelButton",
          cancelBtnClb: null,
          confirmBtnLabel: "goOnButton",
          confirmBtnClb: () => {
            this.duration.isLocked = false;
          }
        },
        {
          root: true
        }
      );
    },
    resetRadioGroupData(activeRadio) {
      switch (activeRadio) {
        case "always":
          this.form.dateRange.dates.from = null;
          this.form.dateRange.dates.to = null;
          this.form.dateRange.dates.period.from = null;
          this.form.dateRange.dates.period.to = null;
          break;
        case "period":
          this.form.dateRange.dates.from = null;
          this.form.dateRange.dates.to = null;
          break;
        case "from":
          this.form.dateRange.dates.to = null;
          this.form.dateRange.dates.period.from = null;
          this.form.dateRange.dates.period.to = null;
          break;
        case "to":
          this.form.dateRange.dates.from = null;
          this.form.dateRange.dates.period.from = null;
          this.form.dateRange.dates.period.to = null;
          break;

        default:
          break;
      }
    },
    getFormattedTimePeriod(slot) {
      return `${this.formatTime(slot.fromHHMM)} - ${this.formatTime(
        slot.toHHMM
      )}`;
    },
    getFormattedValidityPeriod(slot) {
      let validityFrom = this.formatDate(slot.validityFrom);
      let validityTo = this.formatDate(slot.validityTo);
      if (validityFrom && validityTo) {
        return `${validityFrom} - ${validityTo}`;
      } else if (validityFrom) {
        let to = this.$t("weekTimetable.dialog.datePeriod.toLabel");
        return `${to} ${validityFrom}`;
      } else if (validityTo) {
        let from = this.$t("weekTimetable.dialog.datePeriod.fromLabel");
        return `${from} ${validityTo}`;
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year.substring(2)}`;
    },
    updateSlotValidationPeriod() {
      let ref;
      switch (this.form.dateRange.type) {
        case "period":
          ref = "periodFromDateElem";
          break;
        case "to":
          ref = "toDateElem";
          break;
        case "from":
          ref = "fromDateElem";
          break;
      }
      if (!ref) return;
      setTimeout(() => {
        this.$refs[ref].focus();
      }, 200);
    },
    updateDate(datePicker) {
      switch (datePicker) {
        case "datePicker1":
          this.datePicker1 = false;
          break;
        case "datePicker2":
          this.datePicker2 = false;

          break;
        case "datePicker3":
          this.datePicker3 = false;

          break;
        case "datePicker4":
          this.datePicker4 = false;
          break;
        default:
          break;
      }
      // ! Revalidate radio group
      this.$refs.slotValidityPeriodElem.validate();
    },
    validateSlotValidationPeriod(v) {
      let result;
      let msg;
      switch (v) {
        case "always":
          result = true;
          msg = "";
          break;
        case "period":
          result =
            !!this.form.dateRange.dates.period.from &&
            !!this.form.dateRange.dates.period.to;
          msg = this.$t("weekTimetable.dialog.datePeriod.errors.periodDate");
          break;
        case "from":
          result = !!this.form.dateRange.dates.from;
          msg = this.$t("weekTimetable.dialog.datePeriod.errors.onlyFromDate");
          break;
        case "to":
          result = !!this.form.dateRange.dates.to;
          msg = this.$t("weekTimetable.dialog.datePeriod.errors.onlyToDate");
          break;
        default:
          break;
      }
      return result || msg;
    },
    saveWeekAvailability() {
      let payload = {
        timespansList: this.timeList
      };
      if (this.isDurationEnabled) {
        payload.duration = this.duration.value;
      }
      this.$emit("save", payload);
    },
    formatTimeToObject(timeInStringFormat) {
      let parts = timeInStringFormat.split(":");
      return {
        HH: parts[0],
        mm: parts[1]
      };
    },
    submitTimespan() {
      if (!this.isFormValid) return;
      if (this.dialogMode == "new") this.addTimespan();
      else this.editTimespan();
    },
    getDoctorName(doctor) {
      let doctorsList = this.formFields.data.doctor?.value;
      if (!doctorsList) return;
      let d = doctorsList.find(d => d.doctorId == doctor.doctorId);
      return d ? `${d?.name} ${d?.surname}` : "";
    },
    getTimeDiff(start, end) {
      const MINUTES_PER_HOUR = 60;
      const START_HH = parseInt(start.HH);
      const START_MM = parseInt(start.mm);
      const END_HH = parseInt(end.HH);
      const END_MM = parseInt(end.mm);
      let interval1 = MINUTES_PER_HOUR - START_MM;
      let interval2 = parseInt(end.mm);
      let hoursDiffInMinutes;
      if (START_HH == END_HH) return END_MM - START_MM;
      else hoursDiffInMinutes = (END_HH - (START_HH + 1)) * MINUTES_PER_HOUR;
      return interval1 + hoursDiffInMinutes + interval2;
    },
    compareTimes(time1, time2) {
      const TIME1_HH = parseInt(time1.HH);
      const TIME2_HH = parseInt(time2.HH);
      const TIME1_MM = parseInt(time1.mm);
      const TIME2_MM = parseInt(time2.mm);
      let res = 0;
      if (TIME1_HH > TIME2_HH) res = -1;
      if (TIME1_HH < TIME2_HH) res = 1;
      else if (TIME1_MM > TIME2_MM) {
        res = -1;
      } else if (TIME1_MM < TIME2_MM) {
        res = 1;
      } else res = 0;
      return res;
    },
    resetSlotForm() {
      this.form = initFormFieldsData();
    },
    openDialog(mode, timespan) {
      if (!this.editPermission) return;
      this.dialogMode = mode;
      this.dialog = true;
      this.selectedTimespan = null;
      this.resetSlotForm();
      if (mode == "edit") {
        this.selectedTimespan = timespan;
        this.form.selectedDay.id = timespan.day;
        this.form.selectedDoctor.doctorId = timespan.doctorId;
        this.form.timespan.fromHHMM = timespan.fromHHMM;
        this.form.timespan.toHHMM = timespan.toHHMM;
        if (timespan.validityFrom && timespan.validityTo) {
          this.form.dateRange.type = "period";
          this.form.dateRange.dates.period.from = timespan.validityFrom;
          this.form.dateRange.dates.period.to = timespan.validityTo;
        } else if (timespan.validityFrom) {
          this.form.dateRange.type = "from";
          this.form.dateRange.dates.from = timespan.validityFrom;
        } else if (timespan.validityTo) {
          this.form.dateRange.type = "to";
          this.form.dateRange.dates.to = timespan.validityTo;
        } else {
          this.form.dateRange.type = "always";
        }
      }
    },
    closeDialog() {
      this.dialog = false;
      this.resetSlotForm();
    },
    formatTime(time) {
      return `${time.HH}:${time.mm}`;
    },
    getSortedTimespans(timespans) {
      if (!timespans) return [];
      return timespans.slice().sort((ts1, ts2) => {
        if (ts1.HH > ts2.HH) return -1;
        else if (ts1.HH < ts2.HH) return 1;
        else if (ts1.mm > ts2.mm) {
          return -1;
        } else if (ts1.mm < ts2.mm) {
          return 1;
        } else return 0;
      });
    },
    getFormattedDayName(dayName) {
      return dayName.substring(0, 3).toUpperCase();
    },
    addTimespan() {
      this.isFormDirty = true;
      this.dialog = false;
      let startTime = `${this.form.timespan.fromHHMM.HH}:${this.form.timespan.fromHHMM.mm}:00`;
      let endTime = `${this.form.timespan.toHHMM.HH}:${this.form.timespan.toHHMM.mm}:00`;
      let newTimespans = [];
      let dayId = this.form.selectedDay.id;
      let daysNum;
      if (dayId == "WORKING") {
        daysNum = 5;
      } else if (dayId == "ANY") {
        daysNum = 7;
      } else {
        daysNum = 1;
      }
      for (let index = 0; index < daysNum; index++) {
        let newTimespan = {
          day:
            daysNum != 1
              ? this.getDaysOfWeek[index].id
              : this.form.selectedDay.id,
          fromHHMM: startTime,
          toHHMM: endTime,
          doctorId: this.form?.selectedDoctor?.doctorId,
          isNew: true
        };
        let datePeriod = getSlotValidationDatePeriod(this.form);
        newTimespan.validityFrom = datePeriod.validityFrom;
        newTimespan.validityTo = datePeriod.validityTo;
        newTimespans.push(newTimespan);
      }
      newTimespans.forEach(nT => {
        this.timeList.push(nT);
      });
    },
    editTimespan() {
      this.isFormDirty = true;
      this.dialog = false;
      let oldTimespan = { ...this.selectedTimespan };
      oldTimespan.fromHHMM = `${oldTimespan.fromHHMM.HH}:${oldTimespan.fromHHMM.mm}:00`;
      oldTimespan.toHHMM = `${oldTimespan.toHHMM.HH}:${oldTimespan.toHHMM.mm}:00`;
      let newTimespan = { ...this.selectedTimespan };
      let startTime = `${this.form.timespan.fromHHMM.HH}:${this.form.timespan.fromHHMM.mm}:00`;
      let endTime = `${this.form.timespan.toHHMM.HH}:${this.form.timespan.toHHMM.mm}:00`;
      newTimespan.day = this.form.selectedDay.id;
      newTimespan.fromHHMM = startTime;
      newTimespan.toHHMM = endTime;
      newTimespan.doctorId = this.form?.selectedDoctor?.doctorId;
      newTimespan.isUpdated = true;
      let datePeriod = getSlotValidationDatePeriod(this.form);
      newTimespan.validityFrom = datePeriod.validityFrom;
      newTimespan.validityTo = datePeriod.validityTo;
      let oldItemIndex = this.timeList.findIndex(timespan => {
        let timeStartExtentedFormat = `${oldTimespan.fromHHMM}`;
        let timeEndExtentedFormat = `${oldTimespan.toHHMM}`;
        return (
          timespan.day == oldTimespan.day &&
          timespan.doctorId == oldTimespan.doctorId &&
          timespan.fromHHMM == timeStartExtentedFormat &&
          timespan.toHHMM == timeEndExtentedFormat &&
          timespan.validityFrom == oldTimespan.validityFrom &&
          timespan.validityTo == oldTimespan.validityTo
        );
      });
      this.timeList.splice(oldItemIndex, 1, newTimespan);
    },
    removeTimespan(timespan) {
      this.isFormDirty = true;
      let candidateTimespan = { ...timespan };
      candidateTimespan.fromHHMM = `${candidateTimespan.fromHHMM.HH}:${candidateTimespan.fromHHMM.mm}:00`;
      candidateTimespan.toHHMM = `${candidateTimespan.toHHMM.HH}:${candidateTimespan.toHHMM.mm}:00`;
      let index = this.timeList.findIndex(timespan => {
        return (
          timespan.day == candidateTimespan.day &&
          timespan.doctorId == candidateTimespan.doctorId &&
          timespan.fromHHMM == candidateTimespan.fromHHMM &&
          timespan.toHHMM == candidateTimespan.toHHMM
        );
      });
      this.timeList.splice(index, 1);
    }
  }
};
</script>

<style scoped>
.custom-height-dialog {
  height: 400px !important;
}
.duration-field >>> input {
  text-align: center;
}
.error-message {
  color: var(--error);
  height: 30px;
}
.radio-btn {
  height: 50px;
}
.error-messages {
  color: var(--error);
}

.form-label {
  color: black;
  white-space: nowrap;
}
.week-availability__row {
  --error-clr: red;
  --border-clr: grey;
  --new-item-bg-clr: blue;
  --new-item-clr: white;
  border-bottom: 1px solid grey;
  width: 100%;
  min-height: 65px;
}
.timespans-list {
  list-style-type: none;
}
.timespans-list__item {
  display: inline-block;
  height: auto;
}
.slot-chip:hover {
  cursor: pointer;
}
.slot-chip {
  border-radius: 25px !important;
}
.slot-chip__validation-period {
  max-width: 150px !important;
}
.slot-chip__time-period {
  width: 100px !important;
}
.slot-chip__time-doctor {
  max-width: 150px !important;
}
.slot-chip__remove-btn >>> .v-icon {
  color: rgba(255, 255, 255, 0.5) !important;
}
.slot-chip__remove-btn >>> .v-icon:hover {
  color: white !important;
}
.day-col {
  min-width: 70px !important;
  max-width: 70px !important;
  border-right: 1px solid var(--border-clr);
}
.timespan--is-new {
  background-color: var(--secondary);
  color: white;
}
.timespan--is-updated {
  background-color: var(--secondary);
  color: white;
}
.dialog-form-input >>> .v-input__prepend-outer {
  width: 140px !important;
}
.input-field--small {
  min-width: 40px;
  max-width: 40px;
}
/* For Firefox */
.duration-field input[type="number"] {
  -moz-appearance: textfield;
}
/* Webkit browsers like Safari and Chrome */
.duration-field input[type="number"] {
  -webkit-appearance: none;
  margin: 0;
}
/* CUSTOMIZE TIME PICKER */
.custom-time-picker >>> .dropdown {
  z-index: 9999 !important;
  /* top: -110px !important; */
}
.custom-time-picker >>> input {
  border-color: black !important;
  border-top: none;
  border-left: none;
  border-right: none;
}
.custom-time-picker >>> .dropdown ul li:not([disabled]).active {
  background-color: var(--primary) !important;
}
</style>
